import { CommonModule } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { take } from 'rxjs/operators';

@Component({
    selector: 'confirm-delete-dialog',
    imports: [CommonModule, MatButtonModule, MatDialogModule],
    template: `
<div class="joi-dialog small">
  <div mat-dialog-content>
      <div class="title4">{{title}}?</div>
      <div class="para">{{para}}</div>
  </div>
  <div mat-dialog-actions>
      <button mat-button (click)="dialogRef.close()">CANCEL</button>
      <button mat-button [ngClass]="{ green: data.green }" [color]="'warn'" [mat-dialog-close]="{cmd: 'delete'}">{{delete_btn_text}}</button>
  </div>
</div>
`,
    styles: [`
  .joi-dialog.small .title4 { font-size:14px; font-weight:bold; line-height: 22px; }
  .joi-dialog.small .para { font-size:14px; line-height: 22px; }
  .mat-button.mat-warn.green { background: #11b8c1; }
  @media screen and (max-width: 768px) { .cdk-overlay-pane { margin: auto !important } }
  `],
    standalone: true,
})
export class ConfirmDeleteDialogComponent implements OnInit {

  readonly panelHeight = 125;
  title = '';
  para = 'This action cannot be undone.';
  delete_btn_text = 'DELETE';
  constructor(public dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteData) {
      
  }
  ngOnInit() {
      const { rect, deleteButtonText, bottomOffset, title, para, delete_btn_text } = this.data
      // console.log("HELLO FROM CONFIRM DELETE!", this.data)
      if (rect) {
          this.dialogRef.updatePosition({ top: (rect.bottom + 10 + (bottomOffset || 0)) + 'px', left: rect.left + 'px' });
          setTimeout(() => this.updatePosition(), 10);
      }
      if (deleteButtonText) this.delete_btn_text = deleteButtonText
      else if (delete_btn_text) this.delete_btn_text = delete_btn_text

      this.title = title
      if (para) this.para = this.data.para

  }
  private updatePosition() {
      const dWidth = 220;
      const dHeight = 123 + 16 * (Math.floor(this.para.length / 30) + 1);
      const confirmEl = document.getElementById(this.dialogRef.id);
      if (window.innerWidth <= this.data.rect.left + dWidth) {
          confirmEl.parentElement.style.marginLeft = this.data.rect.left - dWidth + 'px';
      }
      // console.log(window.innerHeight, this.data.rect, dHeight);
      if (window.innerHeight <= this.data.rect.bottom + dHeight) {
          confirmEl.parentElement.style.marginTop = this.data.rect.top - dHeight -10 + 'px';
      }
  }
}

export interface ConfirmDeleteData {
  dialog: MatDialog
  rect: any
  title: string
  bottomOffset?: number
  para?: string
  deleteButtonText?: string
  delete_btn_text?: string
  green?: boolean
}

export const openConfirmDeleteGetResult = async (data: ConfirmDeleteData) => {
  const dialog = data.dialog.open(ConfirmDeleteDialogComponent, {
    width: '250px', disableClose: false,  backdropClass:'clear', autoFocus: false, data
  })
  const result = await dialog.afterClosed().pipe(take(1)).toPromise()
  return !!result && result.cmd === 'delete'
}